/* unplugin-vue-components disabled */import { render } from "./home_bottom.vue?vue&type=template&id=45c5de07&scoped=true"
import script from "./home_bottom.vue?vue&type=script&lang=js"
export * from "./home_bottom.vue?vue&type=script&lang=js"

import "./home_bottom.vue?vue&type=style&index=0&id=45c5de07&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c5de07"]])

export default __exports__